import React from 'react';

export default function ServerError() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" style={{enableBackground: "new 0 0 60 60"}} >
      <g>
        <path d="M0 0v60h60V0H0zm20 39h-3v8c0 .552-.448 1-1 1s-1-.448-1-1v-8H9c-.552 0-1-.448-1-1V27c0-.552.448-1 1-1s1 .448 1 1v10h5v-2c0-.552.448-1 1-1s1 .448 1 1v2h3c.552 0 1 .448 1 1s-.448 1-1 1zm16 2.5c0 3.584-2.916 6.5-6.5 6.5S23 45.084 23 41.5v-9c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5v9zM51 39h-3v8c0 .552-.448 1-1 1s-1-.448-1-1v-8h-6c-.552 0-1-.448-1-1V27c0-.552.448-1 1-1s1 .448 1 1v10h5v-2c0-.552.448-1 1-1s1 .448 1 1v2h3c.552 0 1 .448 1 1s-.448 1-1 1zM2 12V2h56v10H2z"/>
        <path d="M54.293 3.293 52 5.586l-2.293-2.293-1.414 1.414L50.586 7l-2.293 2.293 1.414 1.414L52 8.414l2.293 2.293 1.414-1.414L53.414 7l2.293-2.293zM3 3h39v8H3zM29.5 28c-2.481 0-4.5 2.019-4.5 4.5v9c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-9c0-2.481-2.019-4.5-4.5-4.5z"/>
      </g>
    </svg>
  );
}